import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  dialog: {
    zIndex: `1300 !important`,

    '& .MuiPaper-root': {
      width: '90%',
      maxWidth: 600,
      height: '90vh',
    },
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    height: '100vh',
  },

  inputContainer: {
    flex: 1,
    overflow: 'auto',
    marginTop: '66px',
  },

  list: {
    zIndex: 99,
    overflowY: 'visible',
  },

  searchContainer: {
    padding: theme.spacing(2),
    position: 'sticky',
    // top: (p) => p.topVal,
    // backgroundColor: (p) => (get(p, 'searchView.offsetTop', p.topVal) > p.topVal + 45 ? theme.colors.lightBlue : theme.palette.common.white),
    zIndex: 100,
    // width: `calc(100% + 14px)`,
    // marginLeft: -24,

    '& .MuiInputBase-root': {
      backgroundColor: theme.palette.common.white,
    },
  },

  formStyle: {
    position: 'relative',
    maxWidth: '1000px !important',
    overflow: 'visible !important',
    height: 'auto',
  },
  titleStyle: {
    fontSize: '18px !important',
    fontWeight: 'bold',
  },
  screenWidth: {
    width: '100%',
    '& .MuiInput-formControl.Mui-disabled, .MuiInputLabel-formControl': {
      color: theme.palette.text.primary,
    },
    '& .Mui-disabled.MuiInputBase-formControl .MuiSelect-icon': {
      display: 'none',
    },
    '& .Mui-disabled.MuiInput-underline:before': {
      border: `none !important`,
    },
  },
  screenContainer: {
    maxWidth: 'none !important',
  },
  screenContainerMobile: {
    maxWidth: 'none !important',
  },
  dropZone: {
    borderRadius: 10,
  },
}));

export default useStyles;
